import { Button } from '@libs/components';
import { hexColorWithOpacity } from '@libs/helpers';
import { CheckedIcon, Exclamation } from 'src/assets';
import styled, { css, keyframes } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: ${({ theme }) => theme.shadows.sm};
  padding: 1.6rem 1.6rem 1.6rem 4rem;
  background-color: ${({ theme }) => theme.colors.surface.default};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.x6};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.x6};
  padding-top: 8.2rem;
  margin-bottom: 3.4rem;
  ${({ theme }) => theme.media.laptop`
        flex-direction:row;
        padding:3.2rem;
        border-radius: ${
          theme.borderRadius.highM as unknown as TemplateStringsArray
        };
    `};
`;
export const FirstContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 2rem 2rem 2rem 3.9rem;
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  margin-right: 0;
  border-radius: ${({ theme }) => theme.borderRadius.x6};
  border-bottom-left-radius: 0;
  width: 100%;
  ${({ theme }) => theme.media.laptop`
        border-radius: ${
          theme.borderRadius.x6 as unknown as TemplateStringsArray
        };
        width: 50%;
        margin-right:1.2rem;
        padding:2.4rem;
    `};
`;
export const SecondContainerWrapper = styled.div`
  background: linear-gradient(126deg, #00298f 0%, #0e1423 100%);
  border-radius: ${({ theme }) => theme.borderRadius.x6};
  border-top-left-radius: 0;
  width: 100%;
  ${({ theme }) => theme.media.laptop`
        border-radius: ${
          theme.borderRadius.x6 as unknown as TemplateStringsArray
        };
           width: 50%;
    `};
`;
export const SecondContainer = styled.div`
  position: relative;
  padding: 2rem 2rem 2rem 3.9rem;
  border-radius: ${({ theme }) => theme.borderRadius.x6};
  border-top-left-radius: 0;
  box-shadow: -70px 78px 29px 0px rgba(133, 139, 163, 0.01),
    -45px 50px 27px 0px rgba(133, 139, 163, 0.06),
    -25px 28px 23px 0px rgba(133, 139, 163, 0.2),
    -11px 12px 17px 0px rgba(133, 139, 163, 0.33),
    -3px 3px 9px 0px rgba(133, 139, 163, 0.39);
  width: 100%;
  background-image: url(${Exclamation});
  background-repeat: no-repeat;
  background-position-x: right;
  background-position-y: top;
  ${({ theme }) => theme.media.laptop`
        border-radius: ${
          theme.borderRadius.x6 as unknown as TemplateStringsArray
        };
        padding:2.4rem;
    `};
`;
export const BorderLeft = styled.div`
  display: block;
  width: 0.1rem;
  height: 2rem;
  background-color: ${({ theme }) => theme.colors.borders.default};
  ${({ theme }) => theme.media.laptop`
          display:none;
    `};
`;

export const FirstCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5.2rem;
  height: 5.2rem;
  border: 1px solid ${({ theme }) => theme.colors.text.success};
  background-color: #ebf5e8;
  margin-bottom: 4rem;
  margin-bottom: 0;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  position: absolute;
  left: -2.6rem;
  top: 2rem;
  ${({ theme }) => theme.media.laptop`
        left: unset;
        top: unset;
        position:relative;
        margin-bottom:4rem;
    `};
`;
export const SecondCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5.2rem;
  height: 5.2rem;
  border: 2px solid #022781;
  background-color: #f5f8ff;
  margin-bottom: 0;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  position: absolute;
  left: -2.6rem;
  top: 2rem;
  ${({ theme }) => theme.media.laptop`
          left: unset;
          top: unset;
          position:relative;
          margin-bottom:4rem;
    `};
`;
export const Separator = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: ${({ theme }) =>
    hexColorWithOpacity(theme.colors.surface.default, 26)};
  margin: 2rem 0 1.2rem;
`;
export const FirstSeparator = styled.div`
  width: 100%;
  height: 0.4rem;
  background-color: transparent;
  margin: 0;
  ${({ theme }) => theme.media.laptop`
      margin: 2rem 0 1.2rem;
      height: 0.1rem;
      background-color: ${
        theme.colors.borders.default as unknown as TemplateStringsArray
      };

    `};
`;
export const FooterFirst = styled.div`
  margin-top: auto;
  display: none;
  ${({ theme }) => theme.media.laptop`
         display:block;
    `};
`;
export const FooterSecond = styled.div`
  margin-top: 2rem;
`;
export const FooterTextWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: 0.4rem 0.8rem;
  white-space: nowrap;
`;
export const FooterFlex = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.8rem;
`;
export const Dot = styled.div`
  height: 4px;
  width: 100%;
  background-image: repeating-linear-gradient(
    to right,
    ${({ theme }) => theme.colors.borders.default},
    ${({ theme }) => theme.colors.borders.default} 0.6rem,
    transparent 0.6rem,
    transparent 1.2rem
  );
`;
export const DotWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
export const ArrowRight = styled.div`
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;

  border-left: 8px solid ${({ theme }) => theme.colors.borders.default};
`;
export const CustomCheckedIcon = styled(CheckedIcon)`
  width: 2.3rem;
  height: 2.3rem;
`;

const circularAnimation = keyframes`
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
`;

export const CustomButton = styled(Button)`
  position: relative;

  padding: 0 2rem;

  border: 1px solid transparent;

  overflow: hidden;

  z-index: 1;

  &::before {
    content: '';

    position: absolute;
    top: calc(50% - 2.1rem);
    left: 0;

    width: 100%;
    height: 4.2rem;

    border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

    z-index: -2;

    ${({ theme }) => {
      const brandColor = theme.colors.interactive.brandColor;
      const secondary = theme.colors.surface.default;

      return css`
        background: linear-gradient(
              to top,
              ${hexColorWithOpacity(brandColor, 50)},
              ${secondary}
            )
            right,
          linear-gradient(
              to top,
              ${secondary},
              ${hexColorWithOpacity(brandColor, 50)}
            )
            left;
        background-size: 50% 100%, 50% 100%;
        background-repeat: no-repeat;
      `;
    }};

    animation: ${circularAnimation} 3s cubic-bezier(0.32, 0.24, 0.36, 0.35)
      infinite;
  }

  &::after {
    content: '';

    position: absolute;
    top: 0.2rem;
    left: 0.2rem;

    width: calc(100% - 0.4rem);
    height: calc(100% - 0.4rem);

    border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

    background-color: ${({ theme }) => theme.colors.interactive.brandColor};

    z-index: -1;
  }

  ${({ theme }) => {
    const backgroundColor = theme.colors.interactive.brandColorHover;

    return theme.media.laptop`
    &::after {
      transition: background-color 0.3s ease; 
    }

    &:hover::after {
      background-color: ${backgroundColor as unknown as TemplateStringsArray};
    }
  `;
  }}

  &.active {
    border: 1px solid ${({ theme }) => theme.colors.interactive.brandColor};

    background-color: ${({ theme }) => theme.colors.interactive.secondary};
    &::after {
      display: none;
    }

    &::before {
      display: none;
    }
  }
`;
